{
  "021e9a362a4994f4": "Since this professional recently submitted a Missed Punch Request, this request will expire on {{formattedExpiryDate}}.",
  "028ff6788c05afa8": "Edit break time",
  "02a373602df5e9c7": "Skipped break",
  "02a63a5edd1acb79": "New total",
  "0427ec78ba6e5aa9": "Please confirm that this professional was a No Show.",
  "05641494de57fcc2": "Left workplace",
  "08251562b3407a16": "Signed",
  "09adde92f00886ef": "Clock in",
  "0bfb51f390b55eb6": "Edit clock out time",
  "0c68f8811f1b4745": "Decline Break Payment Request",
  "0c843ea50d04fd8d": "mins",
  "0e45302a9b0a1380": "Yes, I'd like Clipboard to post an",
  "12698ce1ea5cd4ab": "Skipped",
  "1610dcd8f5e4eb1d": "Error downloading timesheets",
  "183f9af034b83430": "e.g. Acute care",
  "19766ed6ccb2f4a3": "Cancel",
  "215020d85a22dd6d": "Charge Breakdown",
  "219a8125870cbae2": "Nursing services assignment",
  "23f8b3f3130644fa": "Before you mark No Show, we wanted to flag that the worker seems to be moving towards your workplace.",
  "2682d64f56d4520e": "Please add notes to describe the No Show event in more detail.",
  "29b9c49ceced7a4f": "Failed to decline missed punch request",
  "2eb26f243ef314c9": "Missed Punch Request approved",
  "31a43e88b660bc5f": "Correct & approve",
  "32d57593e0a75d98": "Please review the break time before approving. You can correct the times using the 'Correct & approve' option.",
  "336aa39ab810e1ba": "Provide any relevant details or evidence. E.g., \"when checking our security camera recordings as well as our records, it&apos;s clear you took at least a full break.\"",
  "367a920a4538766d": "A 1099 policy assignment fee will be deducted from worker pay.",
  "378f90f28922eec0": ". Note, you won't be charged any additional fees, just the standard shift rate.",
  "39c825bb1fb21d75": "Missed Punch Request denied",
  "3a3a98ffcc9fbd48": "Since it is uncommon for this professional to submit Missed Punch Requests, this request will auto-approve on {{formattedExpiryDate}}.",
  "3a8931a9b2f6bf69": "Dispute",
  "3eafb1d3e170874c": "This is the break that will be approved for this shift.",
  "3fba5ca0ea213e15": "Error loading signature",
  "427d09f7274f2b9c": "Break start",
  "45733af728fba90d": "Clock out",
  "45b63ffd01af7b9c": "Rate",
  "474e899ce7de15bb": "These are the times that will be approved for this shift.",
  "4ba2e28476a135a9": "Reject and keep original time",
  "4dc118081ffe8038": "Would you like Clipboard to look for a replacement for this shift?",
  "4e58cd5500f23d06": "Provide any relevant details or evidence for approving this request.",
  "4e9682fa850ed767": "hrs",
  "4fc52a3c4c558b51": "Duration",
  "51f015a9ef778940": "View rate breakdown",
  "525c9d4fc3aaa4bc": "Approved clock out",
  "5635fd1470060191": "Distance:",
  "582d5b22c05c968b": "Worker Profile",
  "5d70db404f538fe6": "Last Updated: {{lastUpdatedText}}",
  "5f4ca2b9dc0be27a": "There was an error while loading the break request data. Please try again.",
  "6007acbe30b2cd98": "Approve",
  "61374592cd46e0e5": "Live tracking",
  "61b026bea0a35469": "Requested total",
  "6c549ee1e989f842": "Failed to approve missed punch request",
  "753ed53df5d6e46a": "Sign & Approve",
  "76900f1bfd16c8d4": "Back",
  "77bbaafb4cd49df5": "Verified Shift",
  "79b37076beca8703": "Compliance Videos",
  "79c2657890c42470": "View dispute",
  "7c4812fdf490b279": "Before you mark No Show, we wanted to flag that the worker seems to be within a mile of your workplace.",
  "7d9eb7acb13e2462": "Close",
  "7e18daf2589c64cf": "At or before",
  "805dcf0e47b9268a": "Error loading video.",
  "829ba374dbf79ec2": "Arrived at workplace",
  "83b12c2216efb4fd": "Clear",
  "84a350e29c34791c": "You do not have permission to review the request",
  "861420e5f6afa58d": "Yes, and I am okay with this worker leaving early.",
  "8794e1c96bc12483": "Missed clock in",
  "8866ebaf72d9db46": "Approved break",
  "88d13fb561f5f0ae": "Requested clock in",
  "892359d2dbcea6df": "You do not have permissions to approve/decline Extra Worked Time Requests",
  "896ed1586c784540": "Clock in video",
  "8d1e257246c30f33": "Decline Missed Punch Request?",
  "8e409e7990b1dec4": "Collapse expiry details",
  "8f227bc8dd1f19c3": "Clock in time",
  "901ded342e740048": "Provide any relevant details or evidence.",
  "9527010f2660676a": "{{distanceInMiles}} mi",
  "974fc8fbbcda6c55": "e.g. 2nd floor",
  "9767bb53ab3b0419": "This is the time that will be approved for this shift.",
  "989c2818e8546505": "Did the worker leave with your permission?",
  "9b03a3e87f69497d": "Missed clock out",
  "9c9c3275d4f0b964": "View request",
  "9dcff98e275f0cb9": "Timeline",
  "9df3293f4edcce3a": "Approved clock in",
  "9ed200aeb78c5b9b": "Approve request",
  "a0e33d55f61f537c": "This request includes a {{actualMinutes}} min break, but your workplace policy requires a {{requiredMinutes}} min break.",
  "a17a99d060752978": "Unable to load charge rate details",
  "a2d285b352873457": "Decline",
  "a30973149663f8e2": "This request includes no break, but your workplace policy requires a {{requiredMinutes}} min break.",
  "a56346531cb85449": "Requested break",
  "a5da3ca559b94b1c": "No, this worker left without permission.",
  "a66279e9d80fdce2": "Disagree with the time? Approve a corrected one.",
  "abc9cac5db1dbf64": "I confirm this professional was a No Show.",
  "b141deb247a324d0": "Requested clock out",
  "b25ab4ef060a24e6": "The shift data could not be loaded. Please, try again later.",
  "b37c7879f6c359f6": "Not recorded",
  "b6e84006a2d887fb": "Break Payment Request",
  "b74a51297835aaf2": "Missed Punch Request",
  "b972e0dace316cb7": "Your workplace policy requires a {{requiredMinutes}} min break.",
  "bc79cdffbaa8df09": "More options",
  "bcbee36c4b46574b": "Reject full shift",
  "bd15ec9cca8c0f3a": "Failed to upload signature",
  "bfbcdf460d925a2a": "Why is the worker leaving the shift early?",
  "c12f42ab6906563c": "Confirm times",
  "c192516734d09478": "A 1099 policy assignment fee of {{fee}} will be deducted from worker pay.",
  "c19521a120ed2547": "{{etaMinutes}} mins",
  "c5b309b1e9c2d334": "We are already looking for a replacement worker for this shift. If you still want to cancel the shift, you'll be able to after this step.",
  "c731384aad60d2cc": "New hours",
  "c945ef2b1e798905": "Requested hours",
  "c9b3c38247f744e1": "Total",
  "cba219dacebb145c": "urgent shift",
  "ccde26902b9baa9d": "Paid hours",
  "cd7a2f68b7d6acf7": "No, I don't need a replacement worker for this shift.",
  "d520eeb5335e09be": "Your Professional",
  "d5dc4dc63d4be8b5": "Overridden by {{overriddenByName}}",
  "d61f429ffad6746a": "Break request",
  "d8b80fa1b071170a": "View billable hours",
  "d8c4a2cd2bfcee03": "Clock compliance video",
  "dac73427e17591e5": "Expand expiry details",
  "dcea8abbdff03524": "Review request",
  "de9967524f056889": "Expires in",
  "e005cecbc48072c2": "Clock out time",
  "e060705826724633": "This information will be recorded for audit purposes and may be displayed to the workplace and worker",
  "e2f79e5b60330bba": "N/A",
  "e5752d7cd0661ffa": "ETA:",
  "e6bfe21185e3f9a3": "Please describe the situation",
  "e7031d9ebf8f138f": "Auto-approves in",
  "eaac9a61b76662c5": "Clock out video",
  "ef0ed3ac55b074c5": "We seem to have lost connection.",
  "ef80bb8ce97b8d1d": "Error printing timesheets",
  "f005825b1b5a7719": "{{startTime}} – {{endTime}} ({{durationMinutes}} minutes)",
  "f1a73e2204a11407": "Signature",
  "f246a247c38be344": "Approve Missed Punch Request",
  "f412428aae20acc4": "At or after",
  "f5c12a23ee6fa88d": "Please explain why you are approving this missed punch request on behalf of the workplace.",
  "f71081fb0af48ae6": "Break",
  "f81ab834de5f8491": "Reason",
  "f8761a6adc77d9d0": "This information will be shared with the professional",
  "feb7906e6f52183e": "Station/Wing/Unit/Floor",
  "ff967bedfdeba1aa": "Edit clock in time"
}
